module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAAXNSR0IArs4c6QAAAUlJREFUeF7t2jFqwmAAhuE3tLOnsUtvUOhdunRzduviXaTeoFMv085C5I9EiEkgH82S9HWWwP/myaeCVV3XD/jqFagMM6zCMCNPi2EMkw2pYhSjmKyAYrJeboxiFJMVUEzWy41RjGKyAorJerkxilFMVkAxWS83RjGKyQooJuvlxihGMVkBxWS93JgJYl6BHbAFqqzv4t9dA9/AHjiW07Ri3oCPfxjk/o6WQO/AoYR5Ar6Ax8Xf93kOcAaeS5hP4GWea67mKqcS5gfYrOZI8xzk1zDDIZswPkr9OM2j5Ph2w9zGt/xr04/ra5zOx3X7d1a/4A18wZtny1d0FX8rTfittKL7/fejKEYxmSLFKEYxWQHFZL3cGMUoJiugmKyXG6MYxWQFFJP1cmMUo5isgGKyXm6MYhSTFVBM1suNUYxisgKKyXq5MSO9Lp7M6+3DyTR+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/iv_size_cut.png
// module id = 2IaJ
// module chunks = 1